import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "autofill-handler flow",
    onAnimationstart: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onAutofillAnimationStart && _ctx.onAutofillAnimationStart(...args)))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 32))
}